import { numberMoney, percentage } from 'Data/format.js'

export function getConfiguredDiscount(discount) {
  let setup = ''
  switch (discount?.type) {
    case 'percentage':
      setup = percentage(discount.value)
      break
    case 'amount':
      setup = numberMoney(discount.value)
      break
    default:
      break
  }

  return !setup.length ? setup : `(${setup})`
}
